<template>
    <el-dialog
        ref="DialogItem"
        v-model="visibled"
        :title="title"
        width="500"
        align-center
        draggable
        @closed="onClosed"
        @keyup.enter="doConfirm">
        <el-form
            ref="RuleFormRef"
            :model="data"
            :rules="rules"
            :label-width="60"
            class="label-justify"
            :hide-required-asterisk="true"
            :inline-message="true">
            <el-form-item label="编码" prop="code">
                <el-input
                    v-model="data.code"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="名称" prop="name">
                <el-input
                    v-model="data.name"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="有效期" prop="valid_date">
                <UtcDatePicker
                    v-model="data.valid_date"
                    type="date"
                    placeholder="选填项"
                    format="YYYY-MM-DD" />
            </el-form-item>
            <el-form-item v-if="!is_new" label="状态" prop="state">
                <el-select
                    v-model="data.state"
                    placeholder="必填项">
                    <el-option label="活跃" value="1" />
                    <el-option label="冻结" value="0" />
                </el-select>
            </el-form-item>
        </el-form>
        <div class="foot_div">
            <el-row>
                <el-col :span="4" />
                <el-col :span="6">
                    <el-button
                        class="btn_button"
                        @click="visibled = false">
                        取消
                    </el-button>
                </el-col>
                <el-col :span="4" />
                <el-col :span="6">
                    <el-button
                        class="btn_button"
                        :disabled="!validate"
                        type="primary"
                        @click="doConfirm">
                        保存
                    </el-button>
                </el-col>
                <el-col :span="4" />
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
import {notify, dict, asleep} from '../../assets/js/utils.js';
import UtcDatePicker from '../utils/UtcDatePicker.vue';
import {formatToBJ} from '../../assets/js/time.js';
export default {
    name: 'DialogItem',
    components: {
        UtcDatePicker,
    },
    props: {
    },
    data() {
        return {
            visibled: false,
            resolve: null,
            reject: null,
            title: null,
            data: {},
            list: [],
        };
    },
    computed: {
        validate() {
            return true;
        },
        is_new() {
            return !this.options.data.id;
        },
        rules() {
            // 重复检测
            const validate_duplicate = (rule, value, callback) => {
                const key = rule.field;
                if (this.list.some(x => x[key] === value && x.id !== this.data.id)) {
                    callback(new Error(rule.message ?? `${rule.field} was duplicate.`));
                } else {
                    callback();
                }
            };
            // 字段检测规则;
            const rules = {
                code: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                    {validator: validate_duplicate, message: '重复', trigger: ['change', 'blur']}],
                name: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                    {validator: validate_duplicate, message: '重复', trigger: ['change', 'blur']}],
            };
            return rules;
        },
    },
    mounted() {
    },
    methods: {
        async show(options) {
            console.debug(options);
            this.options = JSON.parse(JSON.stringify(options));
            this.visibled = true;
            this.title = options.title ?? options.data.id ? '修改' : '添加';
            this.list = options.list;
            // fix data
            const empties = [null, undefined, NaN];
            const fields = ['code', 'name', 'valid_date', 'state'];
            const data = dict(Object.entries(options.data).map(([k, v]) => {
                if (typeof v === 'string' || fields.indexOf(k) < 0) return [k, v];
                if (empties.indexOf(v) < 0) return [k, `${v}`];
                return [k, ''];
            }));
            Object.keys(this.data).forEach(k => delete this.data[k]);
            Object.assign(this.data, data);
            Object.assign(this.options.data, data);
            (async () => {
                await asleep(100);
                this.$refs.RuleFormRef?.clearValidate();
            })();
            // prepare dialog return
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        async doConfirm() {
            const form = this.$refs.RuleFormRef;
            try {
                await form.validate();
            } catch (e) {
                console.warn(e);
                notify('error', '填写错误！');
                return;
            }
            // 获取要提交的数据
            const fields = form.fields.map(x => x.prop);
            const empty = ['', null, undefined];
            const newdata = dict(Object.entries({
                ...this.data,
                ...{active: this.data.active === 'true'},
            })
                .filter(([k, v]) => empty.indexOf(v) < 0 && fields.indexOf(k) >= 0));
            if (newdata.valid_date) {
                newdata.valid_date = formatToBJ(newdata.valid_date, 'YYYY-MM-DD');
            }
            // console.log('OLD:', olddata);
            console.log('NEW:', newdata);
            const data = (() => {
                const olddata = {...this.options.data};
                // 添加不需要过滤
                if (!olddata.id) return newdata;
                // 修改过滤未修改参数
                return dict(Object.entries(newdata).filter(([k, v]) => Array.isArray(v)
                    ? JSON.stringify(olddata[k].sort()) !== JSON.stringify(v.sort())
                    : olddata[k] !== v));
            })();
            // 提交数据
            if (Object.entries(data).length) {
                if (data.state !== undefined) data.state = parseInt(data.state);
                console.debug('submit user data:', data);
                try {
                    const res = await this.axios.post(
                        `/admin/api/corporations/${this.data.id || ''}`,
                        {...data, id: this.data.id},
                        {headers: {'Content-Type': 'application/json'}},
                    );
                    if (res.data.error) {
                        notify('error', `${res.data.error} ${res.data?.message}`);
                        return;
                    }
                } catch (e) {
                    notify(e);
                    console.error(e);
                    return;
                }
                this.resolve(data);
                this.reject = null;
                this.visibled = false;
                notify('success', '提交成功！');
            } else {
                notify('warning', '无字段变化！');
            }
        },
        onClosed() {
            if (this.reject) {
                this.reject();
            }
        },
    },
};
</script>

<style>
/* 设置 form item label内文字左右对齐 */
/* 生效方法：<el-form class="label-justify"  label-width="99" ...> */
.el-form.label-justify>div>.el-form-item__label {
    text-align: justify;
    text-align-last: justify;
    display: table-cell;
}
</style>
